import React from 'react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../context/LanguageContext';
import { CloudRain, Shield, Zap, Target, Timer, Leaf } from 'lucide-react';

const iconComponents = [CloudRain, Shield, Zap, Target, Timer, Leaf];

const AdvantagesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="avantages" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6" style={{ color: '#1F4FD8' }}>
            {t.advantages.title}
            {t.advantages.titleHighlight}
          </h2>
          <p className="text-xl text-slate-600">
            {t.advantages.subtitle}
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.advantages.items.map((advantage, index) => {
            const IconComponent = iconComponents[index];
            return (
              <Card
                key={index}
                className="group bg-white border border-slate-200 hover:border-blue-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <CardContent className="p-6">
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#1F4FD8', boxShadow: '0 8px 20px rgba(31, 79, 216, 0.2)' }}>
                    {IconComponent && <IconComponent className="w-7 h-7 text-white" />}
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-4">
                    {advantage.title}
                  </h3>
                  <p className="flex items-start gap-2 text-sm text-slate-600">
                    <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#1F4FD8' }} />
                    {advantage.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Comparison Banner */}
        <div className="mt-16 p-8 rounded-3xl bg-gradient-to-br from-slate-900 to-slate-800 text-white">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold mb-4">{t.advantages.comparison.title}</h3>
              <p className="text-slate-300 leading-relaxed">
                {t.advantages.comparison.description}
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {t.advantages.comparison.stats.map((stat, index) => (
                <div key={index} className="p-4 rounded-xl bg-white/10">
                  <p className="font-bold text-2xl" style={{ color: '#1F4FD8' }}>{stat.value}</p>
                  <p className="text-slate-300 text-sm">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
